(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["photo_carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.photo-carousel-track');
  if (!track) return;

  // Clone les images pour un défilement continu (en JS)
  const clones = track.innerHTML;
  track.innerHTML += clones;

  // Ajuste la vitesse selon le paramètre choisi
  const speed = '{{ section.settings.speed }}';
  let duration = '60s';
  if (speed === 'slow') duration = '90s';
  if (speed === 'fast') duration = '40s';
  track.style.setProperty('--scroll-speed', duration);
});

  } catch(e) { console.error(e); }
})();
})();
